import { Tile, TileHeader, TileTabsRow } from '@creditflowresearch/uilib/Tile';
import Flex from '@creditflowresearch/uilib/Flex';
import { useTopCompaniesAccess } from '@/creditflowresearch/ui/components/TopCompanies/common/useTopCompaniesAccess';
import TopCompaniesTitle from '@/creditflowresearch/ui/components/TopCompanies/common/TopCompaniesTitle';
import TopCompaniesActions from '@/creditflowresearch/ui/components/TopCompanies/common/TopCompaniesActions';
import TopCompaniesTabs from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesTabs';
import TopCompaniesTabSelect from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesTabSelect';
import TopCompaniesRestrictionWrapper
  from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesRestrictionWrapper';
import {
  useTopCompanyCommon,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesCommon/TopCompaniesCommonContext';
import {
  useTopCompanyCommonCorporate,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesCommonCorporate/useTopCompanyCommonCorporate';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';
import { PATH_ONLY_GRANT_CONTEXT } from '@/creditflowresearch/application/User/access/grants/pagePatterns';

import styles from './topCompaniesCommon.module.scss';

interface IProps {
  component: React.ReactNode,
  isCorporate?: boolean,
  commonData: ReturnType<typeof useTopCompanyCommon> | ReturnType<typeof useTopCompanyCommonCorporate>,
  title: string,
  className?: string,
}

const TopCompaniesCommon = ({ component, isCorporate, commonData, title, className }: IProps) => {
  const { activeTab, setActiveTab } = commonData;
  const isAccessible = useTopCompaniesAccess();
  // TODO: remove when the European market opening period ends
  const isOpenAccessPage = useAccessGrant(PATH_ONLY_GRANT_CONTEXT);
  // TODO: remove when the European market opening period ends
  const isTabSwitchingAccessible = isOpenAccessPage || isAccessible;

  return (
    <Tile dataTest="topCompaniesWidget" className={ className }>
      <TileHeader
        title={ <TopCompaniesTitle title={ title } isCorporate={ isCorporate } /> }
        dataTest="topCompaniesHeader"
        noDesktopBottomBorder
      >
        <Flex direction="column" gap={ 10 }>
          <TopCompaniesActions commonData={ commonData } />
          <div className={ styles.mobileTabSelect }>
            <TopCompaniesTabSelect
              activeTab={ activeTab }
              onClick={ setActiveTab }
              isCorporate={ isCorporate }
            />
          </div>
        </Flex>
      </TileHeader>
      <TileTabsRow dataTest="topCompaniesTabs" overlap={ false }>
        <TopCompaniesTabs
          isAccessible={ isTabSwitchingAccessible }
          activeTab={ activeTab }
          onClick={ setActiveTab }
          isCorporate={ isCorporate }
        />
      </TileTabsRow>
      <TopCompaniesRestrictionWrapper>
        { component }
      </TopCompaniesRestrictionWrapper>
    </Tile>
  );
};

export default TopCompaniesCommon;
